module.exports = __webpack_public_path__ + "img/基地.465b096a.png";